<table class="table table-hover" [class.dim]="!crud.complete">
    <thead>
        <tr>
            <th class="w-50">Title</th>
            <th>Type</th>
            <th>Web address</th>
            <th>Published</th>
            <th>In menu</th>
            <th>Order</th>
            <th class="text-end">Actions</th>
        </tr>
    </thead>
    @if (response) {
        <tbody>
            @for (item of response.data; track crud.trackById($index, item)) {
                <tr [class.text-muted]="!item.published">
                    <td>{{ item.title }}</td>
                    <td>
                        <!-- Same pill as the auto-table formatter, inline so this stays self-contained:
                             the seeded info pages read apart from TLC's own, and the lock signals why
                             their address is fixed and they can't be deleted. -->
                        @if (item.system) {
                            <span class="badge rounded-pill bg-primary-subtle text-primary-emphasis border border-primary-subtle">
                                <i class="fa fa-lock me-1" aria-hidden="true"></i>Info page
                            </span>
                        } @else {
                            <span class="badge rounded-pill bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle">Page</span>
                        }
                    </td>
                    <td><code>/{{ item.slug }}</code></td>
                    <td>
                        @if (item.published) {
                            <span class="badge bg-success">Published</span>
                        } @else {
                            <span class="badge bg-light text-dark border">Draft</span>
                        }
                    </td>
                    <td>
                        @if (item.showInMenu) {
                            <i class="fa fa-check text-success" aria-label="In menu"></i>
                        } @else {
                            <span class="text-muted">-</span>
                        }
                    </td>
                    <td>{{ item.sortOrder }}</td>
                    <td class="text-end text-nowrap">
                        <button class="btn btn-sm btn-gray" (click)="crud.modals.form('page', item.id, item)">
                            <i class="fa fa-pencil me-1"></i>Edit
                        </button>
                        <!-- Delete only on TLC's own pages: a system info page's slug is linked to from
                             the entry flow and the homepage, so it has no Delete (the backend refuses it
                             too). -->
                        @if (!item.system) {
                            <button class="btn btn-sm btn-outline-danger ms-1" (click)="remove(item)">
                                <i class="fa fa-trash me-1"></i>Delete
                            </button>
                        }
                    </td>
                </tr>
            }
            @if (!response.data?.length) {
                <tr>
                    <td colspan="7" class="text-muted">No pages yet.</td>
                </tr>
            }
        </tbody>
    }
</table>
